<template>
    <div class="page-container">
        <div class="container-fluid">
            <!-- Navigation Breadcrumb -->
            <div class="page-navigation">
                <div class="breadcrumb-custom">
                    <router-link to="/">
                        <i class="fas fa-home"></i> Home
                    </router-link>
                    <span class="separator">/</span>
                    <span>Latihan Ilmiah</span>
                </div>
            </div>

            <!-- Page Header -->
            <div class="page-header">
                <h2 class="page-title">Latihan Ilmiah</h2>
                <p class="page-subtitle">Laporan kemajuan penulisan Latihan Ilmiah</p>
            </div>

            <div class="row justify-content-center">
                <div class="col-12 col-lg-10">

                    <!-- Tab: semasa / rekod terdahulu -->
                    <ul v-if="previous.length" class="nav nav-tabs mb-3">
                        <li class="nav-item">
                            <a
                                href="#"
                                class="nav-link"
                                :class="{ active: activeTab === 'current' }"
                                @click.prevent="activeTab = 'current'"
                            >Terkini</a>
                        </li>
                        <li class="nav-item">
                            <a
                                href="#"
                                class="nav-link"
                                :class="{ active: activeTab === 'previous' }"
                                @click.prevent="activeTab = 'previous'"
                            >Rekod terdahulu ({{ previous.length }})</a>
                        </li>
                    </ul>

                    <!-- Pendaftaran terkini -->
                    <registration-detail
                        v-if="latest && activeTab === 'current'"
                        :key="latest.id"
                        :registration-id="latest.id"
                    />

                    <!-- Rekod terdahulu -->
                    <div v-if="activeTab === 'previous'">
                        <div class="list-group mb-3">
                            <a
                                href="#"
                                class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                                :class="{ active: selectedPreviousId === item.id }"
                                v-for="item in previous"
                                :key="item.id"
                                @click.prevent="selectedPreviousId = item.id"
                            >
                                <span>
                                    <strong>Cubaan {{ item.attempt }}</strong>
                                    · Semester {{ item.intake_semester }} / {{ item.intake_year }}
                                    <small class="d-block">{{ item.title || '-' }}</small>
                                </span>
                                <span class="badge badge-secondary">{{ item.status_label }}</span>
                            </a>
                        </div>

                        <registration-detail
                            v-if="selectedPreviousId"
                            :key="selectedPreviousId"
                            :registration-id="selectedPreviousId"
                        />
                    </div>

                    <!-- Keadaan kosong -->
                    <div v-if="!loading && !latest" class="empty-state-sm">
                        <i class="fas fa-inbox"></i>
                        <p>Tiada rekod Latihan Ilmiah</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RegistrationDetail from './RegistrationDetail.vue'

export default {
    name: 'LatihanIlmiah',
    components: { RegistrationDetail },
    data() {
        return {
            loading: false,
            activeTab: 'current',
            selectedPreviousId: null,
        }
    },
    computed: {
        ...mapGetters('latihanIlmiah', ['latest', 'previous']),
    },
    mounted() {
        this.loadRegistrations()
    },
    methods: {
        async loadRegistrations() {
            this.loading = true
            this.$Progress.start()
            try {
                await this.$store.dispatch('latihanIlmiah/fetchRegistrations')
                this.$Progress.finish()
            } catch (error) {
                this.$Progress.fail()
                if (error.response && (error.response.status === 401 || error.response.status === 419)) {
                    this.$store.dispatch('authentication/cencelAuthen')
                }
                // eslint-disable-next-line no-console
                console.log(error)
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<style scoped></style>
